import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CircularProgress, Box } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from '@contexts/AuthContext';
import Login from '@components/auth/Login';
import ForgotPassword from '@components/auth/ForgotPassword';
import ResetPassword from '@components/auth/ResetPassword';
import Dashboard from '@components/dashboard/Dashboard';
import Businesses from '@components/businesses/Businesses';
import Machines from '@components/machines/Machines';
import MachineDetails from '@components/machines/MachineDetails';
import MachineDetailsView from '@components/machines/MachineDetailsView';
import ServiceHistory from '@components/serviceHistory/ServiceHistory';
import Jobs from '@components/jobs/Jobs';
import Admin from '@components/admin/Admin';
import Layout from '@components/layout/Layout';
const theme = createTheme({
    palette: {
        primary: {
            main: 'rgb(2, 102, 18)',
        },
        secondary: {
            main: '#dc004e',
        },
    },
});
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    if (loading) {
        return (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }, children: _jsx(CircularProgress, {}) }));
    }
    return isAuthenticated ? _jsx(_Fragment, { children: children }) : _jsx(Navigate, { to: "/login", replace: true });
};
const AdminRoute = ({ children }) => {
    const { isAuthenticated, isAdmin, loading } = useAuth();
    if (loading) {
        return (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }, children: _jsx(CircularProgress, {}) }));
    }
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    if (!isAdmin) {
        return _jsx(Navigate, { to: "/dashboard", replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
const App = () => {
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(AuthProvider, { children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(Login, {}) }), _jsx(Route, { path: "/forgot-password", element: _jsx(ForgotPassword, {}) }), _jsx(Route, { path: "/reset-password", element: _jsx(ResetPassword, {}) }), _jsx(Route, { path: "/*", element: _jsx(ProtectedRoute, { children: _jsx(Layout, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "/dashboard", element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "/machines/:machineId", element: _jsx(MachineDetails, {}) }), _jsx(Route, { path: "/machines/:machineId/details", element: _jsx(MachineDetailsView, {}) }), _jsx(Route, { path: "/machines/:machineId/service-history", element: _jsx(ServiceHistory, {}) }), _jsx(Route, { path: "/machines/:machineId/jobs", element: _jsx(Jobs, {}) }), _jsx(Route, { path: "/businesses", element: _jsx(Businesses, {}) }), _jsx(Route, { path: "/machines", element: _jsx(Machines, {}) }), _jsx(Route, { path: "/service-history", element: _jsx(ServiceHistory, {}) }), _jsx(Route, { path: "/jobs", element: _jsx(Jobs, {}) }), _jsx(Route, { path: "/admin", element: _jsx(AdminRoute, { children: _jsx(Admin, {}) }) })] }) }) }) })] }) }) })] }));
};
export default App;
